import React from 'react';
import { Card, Tag } from 'antd';
import { CalendarOutlined, EyeOutlined } from '@ant-design/icons';
import './index.css';

const ArchiveItem = ({ post }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Card 
      className="archive-item" 
      hoverable
      onClick={() => window.location.href = `/post/${post.id}`}
    >
      <div className="archive-item-header">
        <h3 className="archive-item-title">{post.title}</h3>
        <div className="archive-item-meta">
          <span className="archive-item-date">
            <CalendarOutlined /> {formatDate(post.createdAt)}
          </span>
          <span className="archive-item-views">
            <EyeOutlined /> {post.views || 0}
          </span>
        </div>
      </div>
      
      <div className="archive-item-content">
        <p className="archive-item-excerpt">{post.excerpt}</p>
        <div className="archive-item-tags">
          {post.tags?.map(tag => (
            <Tag key={tag} color="blue">{tag}</Tag>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default ArchiveItem;